import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import { updateInteractionsOpenAction } from 'actions/updateInteractionsOpenAction';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import onScrollEnds from 'services/onScrollEnds';
import { Block } from '@chameleoncreator/creator-app';
import { getTopicsNotHiddenFromNextAndBackNavigation } from 'services/getTopicsNotHiddenFromNextAndBackNavigation';

const store = getStore();

let checkWindowHasScrolled;

const navToNextTopic = () => {
  const topics = getTopics();

  const topicsNotHiddenFromNextAndBackNavigation = getTopicsNotHiddenFromNextAndBackNavigation(
    topics
  );

  const nextTopic =
    topicsNotHiddenFromNextAndBackNavigation[
      topicsNotHiddenFromNextAndBackNavigation.findIndex(
        t => t.id === (getCurrentTopic() as Block).id
      ) + 1
    ];

  if (!nextTopic) return;

  setCurrentTopic(nextTopic.id);

  window.scrollTo(0, 0);

  if (
    window['CHAMELEON_EVENTS_API'] &&
    typeof window['CHAMELEON_EVENTS_API'] === 'function'
  ) {
    window['CHAMELEON_EVENTS_API']('NAVIGATION_TO_NEXT_TOPIC');
  }
};

const next = (sId: number, id: string) => l => {
  if (l !== 'next') {
    // console.log('branching');

    window.location.hash = l;
    return;
  }

  (window as any).locationHistory = null;

  store.dispatch(updateInteractionsOpenAction(id));

  const getNextInteraction = () => {
    // we've already calculated all the next interaction ids in state
    // go use that

    // testing this
    const interactions = Array.from(
      document.querySelectorAll('section')
      // '.intersection-observed' ||
    );

    const nextInteraction: any =
      interactions[interactions.findIndex(i => i.id === `i${id}`) + 1];

    return nextInteraction;
  };

  requestAnimationFrame(() => {
    const nextInteraction = getNextInteraction();

    const windowScrollY = window.scrollY;

    clearTimeout(checkWindowHasScrolled);

    if (nextInteraction) {
      nextInteraction.scrollIntoView({
        behavior: 'smooth',
      });

      checkWindowHasScrolled = setTimeout(() => {
        if (window.scrollY === windowScrollY) {
          nextInteraction.scrollIntoView();
          // console.log(
          //   'smooth scrolling failed so we attempt to snap to the nextInteraction'
          // );
        } else {
          // console.log('we have smooth scrolled to the next interaction');
        }
      }, 300);

      //

      onScrollEnds(() => {
        nextInteraction.focus({
          preventScroll: true,
        });
      });
      //
    } else {
      navToNextTopic();
    }
  });
};

export default next;
